import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetReceiptData } from "api/publicApi";
import { imageUploadBrandPublicAPI } from "api/publicApi";
import { createBrandPublicAPI } from "api/publicApi";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  loading: false,
};

export const createBrandPublic = createAsyncThunk(
  "public/createBrandPublic",
  async (brandData, { rejectWithValue }) => {
    try {
      const response = await createBrandPublicAPI(brandData);
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const imageUploadBrandPublic = createAsyncThunk(
  "public/imageUploadBrandPublic",
  async (brandData, { rejectWithValue }) => {
    try {
      const response = await imageUploadBrandPublicAPI(brandData);
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);
export const getReceiptData = createAsyncThunk(
  "public/getReceiptData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await GetReceiptData(id);
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

const publicSlice = createSlice({
  name: "public",
  initialState,
  reducers: {
    resetPublicState: (state) => {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createBrandPublic.pending, (state) => {
        state.loading = true;
      })
      .addCase(createBrandPublic.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createBrandPublic.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(imageUploadBrandPublic.pending, (state) => {
        state.loading = true;
      })
      .addCase(imageUploadBrandPublic.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(imageUploadBrandPublic.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { resetPublicState } = publicSlice.actions;
export default publicSlice.reducer;
